module.exports = __webpack_public_path__ + "static/media/backgroundLogin.aece150c.webp";